/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarSellerInfo_viewer = {
    readonly isReviewsEnabled: boolean | null;
    readonly " $refType": "PdpRespSidebarSellerInfo_viewer";
};
export type PdpRespSidebarSellerInfo_viewer$data = PdpRespSidebarSellerInfo_viewer;
export type PdpRespSidebarSellerInfo_viewer$key = {
    readonly " $data"?: PdpRespSidebarSellerInfo_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarSellerInfo_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarSellerInfo_viewer",
  "selections": [
    {
      "alias": "isReviewsEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "ORDER_FEEDBACK"
        }
      ],
      "kind": "ScalarField",
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale(featureName:\"ORDER_FEEDBACK\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '321cdfee61404af5e789b9c50e2fb7fd';
export default node;
